import React, { useEffect, useRef, useState } from 'react';
import { ReCAPTCHAWrapper } from '../../shared/components';
import { equals, path } from 'ramda';

const getRecaptchaWindow = () => [...document.getElementsByTagName('iframe')]
  ?.find((x) => x.src.includes('google.com/recaptcha/api2/bframe'))
  ?.parentNode
  ?.parentNode;

const withRecaptchaHOC = (Component) => {

  return (props) => {

    const recaptchaRef = useRef();
    const [observer, setObserver] = useState(null);
    const [disconnect, setDisconnect] = useState(false);

    const recaptchaPopUpObserver = (callbackOnCancel) => {
        const recaptchaWindow = getRecaptchaWindow();
        if (!recaptchaWindow) return null;

        const observerHandler = () => {
          const visibility = path(['style', 'visibility'], recaptchaWindow);
          const isVisible = equals(visibility, 'visible');
          if (isVisible) return null;
          // on click outside popup
          callbackOnCancel();
          setDisconnect(true);
        };

        const options = { attributeFilter: ['style'] };
        const observer = new MutationObserver(observerHandler);
        observer.observe(recaptchaWindow, options);
        return observer;
    }

    const getRecaptchaTokenAsync = async ({ callbackOnCancel }) => {
      const obs = recaptchaPopUpObserver(callbackOnCancel);
      setObserver(obs);
      const token = await recaptchaRef.current.executeAsync();
      recaptchaRef.current.reset();
      return token;
    };

    useEffect(() => {
      if (!disconnect || !(observer instanceof MutationObserver)) return;
      observer.disconnect();
      setObserver(null);
      setDisconnect(false);
    }, [disconnect, observer]);

    useEffect(() => {
      return () => {
        if (observer instanceof MutationObserver) observer.disconnect();
        recaptchaRef.current.reset();
      }
    }, []);

    return (
      <>
          <ReCAPTCHAWrapper recaptchaRef={ recaptchaRef } />
          <Component { ...props } recaptchaRef={ recaptchaRef } getRecaptchaTokenAsync={ getRecaptchaTokenAsync } />
        </>
      );
  };
};

export default withRecaptchaHOC;